import React from "react";
import styled from "styled-components";
import { Person } from "@domain/user/user";
import { fullName } from "@domain/user/utils";
import { mobile } from "@ui/styles/utils";
import { Clamp } from "@ui/components/containers/clamp";
import { stack, Stack } from "@ui/components/layout";
import { ImageSize, ProfilePicture } from "./profilePicture";

interface UserDetailedViewProps extends React.HTMLAttributes<HTMLDivElement> {
	user: Omit<Person, "id">;
	showDescription?: boolean;
	size?: ImageSize;
}
export const UserDetailedView: React.FC<UserDetailedViewProps> = ({ user, showDescription, size, ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			<ProfilePicture picture={user.avatar} size={size ?? "XL"} shadowed fallbackType={user.type} />
			<Stack gap={1} align="center" justify="center">
				<Name size={1}>{fullName(user)}</Name>
				{showDescription && <Description size={1}>{user.description}</Description>}
			</Stack>
		</Container>
	);
};

const Container = styled.div`
	${stack(10, "center", "center")}
`;

const Name = styled(Clamp)`
	font-size: 0.938rem;
	font-weight: 700;
	@media ${mobile} {
		font-size: 0.588rem;
	}
`;

const Description = styled(Clamp)`
	font-weight: 400;
	font-size: 0.625rem;
	line-height: 13px;
`;
